import { zodResolver } from '@hookform/resolvers/zod';
import { Box, Button, CardContent, Grid, IconButton, Typography } from '@mui/material';
import { memo, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { z } from 'zod';
import showToast from '../../../../../components/Hot-Toast/showToast';
import { useTMutation } from '../../../../../utils/useTMutation';
import { useTQuery } from '../../../../../utils/useTQuery';
// import { nextStep } from '../../../../../slice/onBoardWizardSlice';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ASSESSMENT from "../../../../../assets/images/big/Assessment.png";
import CERTIFICATIONS from "../../../../../assets/images/big/certifications.png";
import CHECK from "../../../../../assets/images/big/check.png";
import IMAGE from "../../../../../assets/images/big/checklist.png";
import { customStep, nextStep, previousStep, update } from '../../../../../slice/multiStepSlice';
// Define schema for form validation
export const roleSchema = z.object({
  ROLE_IDS: z.array(z.string()).min(1, { message: "At least one role must be selected" }),
});

const ChecklistData = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { values } = useSelector((state) => state?.multiStep)
  const [roles, setRoles] = useState([]);
  const [selectedRoles, setSelectedRoles] = useState([]);

  const { data: rolesData } = useTQuery(
    "jobs_roles",
    "/jobRoles",
    "post"
  );

  useEffect(() => {
    if (rolesData?.STATUS) {
      setRoles(rolesData.OUTPUT);
    }
  }, [rolesData]);
  useEffect(() => {
    if (values.ROLE_IDS) setSelectedRoles(values.ROLE_IDS);
  }, [values])
  const {
    control,
    handleSubmit,
    setValue,
    clearErrors,
    formState: { errors },
  } = useForm({
    resolver: zodResolver(roleSchema),
    defaultValues: { ROLE_IDS: values.ROLE_IDS || [] },
  });

  const { mutateAsync } = useTMutation("/addUpdateSpecialty", "post", (response) => {
    return response
  });

  const submitChecklistData = async (formData) => {
    try {
      const response = await mutateAsync({
        ...formData,
        ID: values?.ID
      });

      if (response.STATUS) {
        dispatch(update({ ROLE_IDS: formData?.ROLE_IDS }))
        showToast("success", response.MESSAGE, 3000);
        dispatch(nextStep())
        // navigate("/admin/profile-criteria/fetchSpecialtyRoleMappings")
      } else {
        showToast("error", response.MESSAGE, 3000);
      }

    } catch (error) {
      console.error("Add Request failed:", error);
      showToast("error", "Something went wrong, Please try again", 3000);
    }
  };



  const handleChipDelete = (roleId) => {
    setSelectedRoles((prev) => prev.filter(id => id !== roleId));
    setValue('ROLE_IDS', selectedRoles.filter(id => id !== roleId));
    clearErrors('ROLE_IDS');
  };

  const handleRoleChange = (event) => {
    const selectedRoleId = event.target.value;
    if (selectedRoleId && !selectedRoles.includes(selectedRoleId)) {
      const updatedRoles = [...selectedRoles, selectedRoleId];
      setSelectedRoles(updatedRoles);
      setValue('ROLE_IDS', updatedRoles);
    }
  };
  console.log("asdasd", roles, values)

  return (
    <>
      {!values.REDIRECT && <Button
        onClick={() => dispatch(previousStep())}
        startIcon={<ArrowBackIosIcon sx={{ fontSize: "12px", color: "#000000" }} />}
        sx={{ textTransform: 'none', fontWeight: 500, fontSize: "14px", padding: 3, minWidth: 0 }}
      >
      </Button>}
      <Box>
        <CardContent>
          <Typography variant="h2" component="div" mb={4} style={{ fontWeight: 600, fontSize: "24px", color: "#000000", opacity: "87%" }}>
            Add checklist, assessment & certifications
          </Typography>
          <form onSubmit={handleSubmit(submitChecklistData)}>


            {/* Add Document Section */}
            <Grid
              container
              alignItems="center"
              justifyContent="space-between"
              style={{
                padding: '10px 0',
                backgroundColor: '#f5f5f5',
                borderRadius: 8,
                marginBottom: 10,

              }}
              onClick={() => {
               dispatch(nextStep());
              }}
            >
              <Grid item xs={2} style={{ display: 'flex', justifyContent: 'center' }} >
                <div style={{
                  //   backgroundColor: '#6ebe44',
                  width: 42,
                  height: 42,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  borderRadius: '50%'

                }}>

                  <img src={IMAGE} alt="image" />
                </div>
              </Grid>
              <Grid item xs={8}>
                <Typography style={{ fontWeight: "medium", fontSize: "14px", color: "#000000", opacity: "87%", fontWeight: 700 }}>Checklist</Typography>
              </Grid>
              <Grid item xs={2} style={{ textAlign: 'right' }}>
                <IconButton style={{ color: '#6ebe44', cursor: "pointer" }}>
                  {/* <AddIcon onClick={()=>navigate("/clinician/profile/uploaddocuments")} /> */}
                  <img src={CHECK} alt="image" />
                </IconButton>
              </Grid>
            </Grid>



            {/* Issue Date Section */}
            <Grid
              container
              alignItems="center"
              justifyContent="space-between"
              style={{
                padding: '10px 0',
                backgroundColor: '#f5f5f5',
                borderRadius: 8,
                marginBottom: 10,

              }}
              onClick={() => {
                dispatch(customStep(5));
               }}
            >
              <Grid item xs={2} style={{ display: 'flex', justifyContent: 'center' }}>
                <div style={{
                  //   backgroundColor: '#3bb9e3',
                  width: 42,
                  height: 42,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  borderRadius: '50%'
                }}>

                  <img src={ASSESSMENT} alt="image" />
                </div>
              </Grid>
              <Grid item xs={8}>
                <Typography style={{ fontWeight: "medium", fontSize: "14px", color: "#000000", opacity: "87%", fontWeight: 700 }}>Assessment</Typography>
              </Grid>
              <Grid item xs={2} style={{ textAlign: 'right' }}>
                <IconButton style={{ color: '#6ebe44', cursor: "pointer" }}>
                  <ArrowForwardIosIcon
                    //    onClick={()=>navigate("/clinician/profile/issuedates")}
                    style={{ color: '#6ebe44', width: 20, height: 20 }} />

                </IconButton>
              </Grid>
            </Grid>

            {/* Expiration Date Section */}
            <Grid
              container
              alignItems="center"
              justifyContent="space-between"
              style={{
                padding: '10px 0',
                backgroundColor: '#f5f5f5',
                borderRadius: 8,
                marginBottom: 10,

              }}
              onClick={() => {
                dispatch(customStep(7));
               }}
            >
              <Grid item xs={2} style={{ display: 'flex', justifyContent: 'center' }}>
                <div style={{
                  backgroundColor: '#D4602C',
                  width: 42,
                  height: 42,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  borderRadius: '50%'
                }}>

                  <img src={CERTIFICATIONS} alt="image" />
                </div>
              </Grid>
              <Grid item xs={8}>
                <Typography style={{ fontWeight: "medium", fontSize: "14px", color: "#000000", opacity: "87%", fontWeight: 700 }}>Certifications</Typography>
              </Grid>
              <Grid item xs={2} style={{ textAlign: 'right' }}>
                <IconButton style={{ color: '#fff' }}>
                  <ArrowForwardIosIcon
                    //   onClick={()=>navigate("/clinician/profile/expirationdates")}
                    style={{ color: '#6ebe44', width: 20, height: 20 }} />
                </IconButton>
              </Grid>
            </Grid>


            <Box sx={{ display: 'flex', justifyContent: 'flex-end', }}>
              <Button 
              // variant="contained" sx={{ backgroundColor: '#6ebe44' }} 
              className='gradientAdminThemeColor'
              type='submit'>
                Finish
              </Button>
            </Box>
          </form>
        </CardContent>
      </Box>

    </>
  );
};

export default memo(ChecklistData);
